module.exports = __webpack_public_path__ + "static/media/1POLICY25.823f2668.jpg";